var _circle, _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitterIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 21,
    r: 21,
    fill: "#121B5C"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_661_1813)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_661_1813",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 12,
    width: 18,
    height: 18
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 12H30V30H12V12Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_661_1813)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.175 12.8433H28.9354L22.9054 19.7527L30 29.1564H24.4457L20.0923 23.4543L15.1166 29.1564H12.3536L18.8027 21.7635L12 12.8445H17.6957L21.6249 18.0555L26.175 12.8433ZM25.2043 27.5004H26.7343L16.86 14.4131H15.2194L25.2043 27.5004Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_661_1813"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(12 12)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterIcon1);
export default __webpack_public_path__ + "static/media/twitter-icon-1.8c63e579f3962871e96faf68f9327086.svg";
export { ForwardRef as ReactComponent };